import { createContext } from 'react';

const LocationContext = createContext(window.location.pathname);

export default LocationContext;
